import { all } from 'redux-saga/effects';
import subscription from './subscription';

export const subscriptionSaga = function* root() {
  yield all([subscription()]);
};
